<template>
  <div>
    <div class="bg-scroll bg-center bg-cover books">
      <h1 class="is-size-1 has-text-white font-second--bold">Books</h1>
    </div>
    <div class="books-body">
      <div class="level section">
        <div class="level-item ">
          <div class="card ">
            <div class="card-image book">
              <figure class="figure">
                <img :src="Grammar" />
              </figure>
            </div>
            <div class="card-content">
              <h2 class="font-main is-size-5 is-size-6-mobile">
                Invitation to Biblical Hebrew
              </h2>
              <p class="content font-main--italic">Kregel, 2006</p>
            </div>
            <div class="card-footer">
              <a
                class="card-footer-item font-main"
                href="https://www.amazon.com/Invitation-Biblical-Hebrew-Beginning-Theological/dp/0825426502 "
                target="_blank"
              >
                <span class="is-size-7-mobile">Textbook</span>
                <span class="icon ">
                  <i class="fab fa-amazon is-size-5-fullhd" />
                </span>
              </a>
              <a
                class="card-footer-item font-main"
                href=" https://www.amazon.com/Invitation-Biblical-Workbook-Theological-Studies/dp/0825426529/ref=sr_1_2?crid=2YJOFHOJWF3D&dchild=1&keywords=invitation+to+biblical+hebrew&qid=1595956074&sprefix=invitation+to+biblic%2Caps%2C164&sr=8-2 "
                target="_blank"
              >
                <span class="is-size-7-mobile">Workbook</span>
                <span class="icon ">
                  <i class="fab fa-amazon is-size-5-fullhd" />
                </span>
              </a>
              <a
                class="card-footer-item font-main"
                href=" https://www.amazon.com/Invitation-Biblical-Hebrew-Russell-Fuller/dp/0825426510 "
                target="_blank"
              >
                <span class="is-size-7-mobile">DVDs</span>
                <span class="icon ">
                  <i class="fab fa-amazon is-size-5-fullhd" />
                </span>
              </a>
            </div>
          </div>
        </div>
        <div class="level-item ">
          <div class="card book">
            <div class="card-header"></div>
            <div class="card-image book">
              <figure class="figure">
                <img class="image" :src="Syntax" />
              </figure>
            </div>
            <div class="card-content">
              <h2 class="font-main is-size-5 is-size-6-mobile">
                Invitation to Biblical Hebrew Syntax
              </h2>
              <p class="content font-main--italic">Kregel, 2017</p>
            </div>
            <div class="card-footer">
              <a
                class="card-footer-item font-main"
                href="https://www.amazon.com/Invitation-Biblical-Hebrew-Syntax-Intermediate/dp/0825442575/ref=pd_lpo_14_t_1/141-7232266-0764266?_encoding=UTF8&pd_rd_i=0825442575&pd_rd_r=d7c2db36-74d2-4e60-be01-5055ce2454d5&pd_rd_w=SyoQE&pd_rd_wg=Zgf41&pf_rd_p=7b36d496-f366-4631-94d3-61b87b52511b&pf_rd_r=Z26HNBZ4ZX5QP4E6GYZN&psc=1&refRID=Z26HNBZ4ZX5QP4E6GYZN"
                target="_blank"
              >
                Textbook
                <span class="icon ">
                  <i class="fab fa-amazon is-size-5-fullhd" />
                </span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Syntax from '@/assets/Syntax.jpg'
import Grammar from '@/assets/Grammar.jpg'
import Workbook from '@/assets/Workbook.jpg'

export default {
  name: 'Books',
  data() {
    return {
      Grammar,
      Syntax,
      Workbook,
    }
  },
}
</script>
<style lang="scss" scoped>
@import '@/assets/css/_vars.scss';
@import '@/assets/css/_colors.scss';
.books {
  background-image: $mask-dark, url('../assets/Tehillim.jpg');
  position: relative;
  overflow-y: visible;
  height: 20em;
  & > h1 {
    position: absolute;
    top: 50%;
    left: 10%;
  }
}
.books-body {
  min-height: 100vh;
  width: 100vw;
  width: 100%;
  padding: 1em 3em;
  border: 1px solid $primary;
  padding: 5%;
}
.figure {
  display: flex;
  justify-content: center;
}

.card-image.book {
}
</style>
